<div class="messageContainer" *ngFor="let record of sortedRecords" [ngClass]="{'leftMessageContainer': record.direction === 'left'}">
  <ng-container class="imageContainer" *ngIf="(record?.type === 'message' || record?.type === 'call_concluded' || record?.type === 'call_missed')  else serviceReview">
    <ng-container *ngIf="!record?.profileResponse?.profileImg && record?.senderName!='HOME365_BOT'">
      <div class="circle-name-m user-img">
        {{ getShortName(record?.senderName) }}
      </div>
    </ng-container>
    <ng-container *ngIf="record?.profileResponse?.profileImg && record?.senderName!='HOME365_BOT'"><img class="circle-name-m" [src]="record?.profileResponse?.profileImg" alt="image"/></ng-container>
    <ng-container *ngIf="record?.senderName === 'HOME365_BOT'"><img class="circle-name-m" [src]="'./assets/img/home365_logo_small.svg'" alt="image"/></ng-container>
    <div class="messageDataContainer" [ngClass]="{'left': record.direction === 'left'}">
      <header>
        <div class="name">{{record?.senderName === 'HOME365_BOT' ? 'Home365 Support' : record?.senderName}}</div>
        <div class="date">{{record?.createdAt | date : 'M/d/yy, h:mm a'}}</div>
      </header>
      <div  class="body" [ngSwitch]="record.type">
        <div *ngSwitchCase="'message'">
          <div class="body" [innerHTML]="record.message"></div>
        </div>
        <div *ngSwitchCase="'call_concluded'">
          <div class="playContainer">
            <audio class="audio" controls >
              <source [src]="record.audioFile" type="audio/mpeg">
            </audio>
            <!-- <div class="icon" (click)="audio(record.id)">
              <i class="fa-solid fa-play" *ngIf="!record.playing" ></i>
              <i class="fa-solid fa-stop" *ngIf="record.playing" ></i>
            </div>
            <div class="text">Call Concluded</div> -->
          </div> 
          <div class="bodyText" [innerHTML]="record.message"></div>
      </div>
      <div *ngSwitchCase="'call_missed'">
        <div class="playContainer pink">
          <div class="iconNoBack">
            <i class="fa-light fa-phone-missed"></i>
          </div>
          <div class="text">Attempted Call Missed </div>
        </div>
        <div class="bodyText" [innerHTML]="record.message"></div>
      </div>
      </div>


      <div class="files" *ngIf="record.type === 'message' && record != undefined && record.imageCount > 0">
        <lib-carousel
          class="home365-carousel"
          [allowPrimaryCellsSelection]="false"
          [isOwner]="false"
          [cellsToShow]="5"
          [images]="record.imagesCarousel"
          [arrowsOutside]="false"
          [cellWidth]="60"
          [maxCellWidth]="60"
          [height]="60"
          [borderRadius]="0"
          [objectFit]="'cover'"
          [arrowsTheme]="'dark'"
          [allowDelete]="false"
          [leftArrow]="-40"
          (events)="handleCarouselEvents($event, record.id)"
        ></lib-carousel>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #serviceReview>
  <ng-content></ng-content>
</ng-template>

<div class="spinnerBox" *ngIf="chatLoading" [ngClass]="{'spinnerBox_ticketView': view === 'ticket'}">
  <mat-spinner diameter="70"></mat-spinner>
</div>